import { getAssistantActions, getUserActions } from "../../utils/taskActions";
import { 
  Wrench,
  CalendarClock,
  AlertCircle,
  Archive,
  FolderInput,
  PlusCircle,
  CheckCircle,
  ArrowUp,
  ArrowDown,
  ArrowRight,
  Reply,
  PencilOff,
  TicketPlusIcon
} from "lucide-react";

import { formatActionTypeLabel } from "../../utils/formatter";

// switch (action.type) {
//   case 'archive':
//     return 'Archived';
//   case 'reply':
//     return 'Replied';
//   case 'move-to-label':
//     return `Moved to ${formatTitleCase(labels?.find(label => label.id === action.metaData.labelId)?.name || action.type)}`;
//   case 'create-a-task':
//     return 'Created a Task';
//   case 'add-to-project':
//     return 'Added to Project';
//   case 'complete':
//     return 'Marked Complete';
//   case 'reschedule':
//     return 'Reschedule Required';
//   case 'mark-blocked':
//     return 'Task Blocked';
//   case 'raise-priority':
//     return 'Raise Priority';
//   case 'drop-priority':
//     return 'Drop Priority';
//   case 'raise-question':
//     return 'Question Raised';
//   case 'raise-issue':
//     return 'Issue Raised';
//   default:
//     return action.type;
// }

export const TaskActionRibbon = ({ item, labels=undefined, readOnlyMode }) => {

const getActionConfig = (action, item) => {
  const badgeCoreStyles = 'ml-0 font-semibold px-2 py-1 rounded-lg whitespace-nowrap';

  switch (action.type) {
    case 'archive':
      return {
        icon: (readOnlyMode && !item?.archived) ? <PencilOff size={24} className="text-stone-600 mt-1" /> : <Archive size={24} className="text-stone-600 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-stone-500 border-stone-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-stone-50 rounded-lg border border-stone-100 animate-fade-in'
      };
    case 'reply':
      return {
        icon: <Reply size={24} className="text-cyan-700 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-cyan-700 border-cyan-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-cyan-50 rounded-lg animate-fade-in'
      };
    case 'move-to-label':
      return {
        icon: (readOnlyMode && !item?.archived) ? <PencilOff size={24} className="text-indigo-600 mt-1" /> : <ArrowRight size={24} className="text-indigo-600 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-indigo-600 border-indigo-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-indigo-50 rounded-lg animate-fade-in'
      };
    case 'create-a-task':
      return {
        icon: <PlusCircle size={24} className="text-emerald-600 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-emerald-600 border-emerald-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-emerald-50 rounded-lg animate-fade-in'
      };
    case 'create-a-maintenance-ticket':
      return {
        icon: <TicketPlusIcon size={24} className="text-emerald-600 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-emerald-600 border-emerald-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-emerald-50 rounded-lg animate-fade-in'
      };
    case 'add-to-project':
      return {
        icon: <FolderInput size={24} className="text-indigo-700 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-indigo-700 border-indigo-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-indigo-100 rounded-lg border border-indigo-100 animate-fade-in'
      };
    case 'complete':
      return {
        icon: <CheckCircle size={24} className="text-green-600 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-green-600 border-green-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-green-50 rounded-lg animate-fade-in'
      };
    case 'reschedule':
      return {
        icon: <CalendarClock size={24} className="text-red-500 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-red-500 border-red-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-red-50 rounded-lg animate-fade-in'
      };
    case 'mark-blocked':
      return {
        icon: <AlertCircle size={24} className="text-zinc-600 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-zinc-600 border-zinc-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-zinc-100 rounded-lg animate-fade-in'
      };
    case 'raise-priority':
      return {
        icon: <ArrowUp size={24} className="text-purple-600 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-purple-600 border-purple-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-purple-50 rounded-lg border border-purple-100 animate-fade-in'
      }
    case 'drop-priority':
      return {
        icon: <ArrowDown size={24} className="text-purple-600 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-purple-300 border-purple-200`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-purple-50 rounded-lg animate-fade-in'
      };
    case 'raise-question':
      return {
        icon: <AlertCircle size={24} className="text-amber-500 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-amber-500 border-amber-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-amber-50 rounded-lg animate-fade-in'
      };
    case 'raise-issue':
      return {
        icon: <AlertCircle size={24} className="text-rose-600 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-rose-600 border-rose-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-rose-50 rounded-lg border border-rose-100 animate-fade-in'
      };
    default:
      return {
        icon: <Wrench size={24} className="text-stone-500 mt-1" />,
        badge: <div className={`${badgeCoreStyles} text-white bg-stone-500 border-stone-100`}>{formatActionTypeLabel(action, labels)}</div>,
        styles: 'bg-stone-50 rounded-lg border border-stone-100 animate-fade-in'
      };
  }
}

  return (
    <>
      {getAssistantActions(item?.actions)?.map((action, actionIndex) => (
        <div key={`assistant-action-${actionIndex}-${action.type}`} className={`w-full ${actionIndex === getAssistantActions(item?.actions).length - 1 ? '' : 'mb-1'}`}>
          <div className={`flex flex-col justify-start items-start gap-2 p-2 w-full ${getActionConfig(action)?.styles}`}>
            <div className="flex flex-row items-center gap-2 w-full">
              {getActionConfig(action, item)?.icon}
              {getActionConfig(action)?.badge}
            </div>
            <p className="text-gray-700 text-md leading-tight">{action.reason}</p>
          </div>
        </div>
      ))}
      {getUserActions(item?.actions)?.map((action, actionIndex) => (
        <div key={`parent-action-${actionIndex}-${action.type}`} className="flex flex-row items-center justify-start w-fit gap-2 py-2 px-2 border-stone-200 border bg-white rounded-md p-1 mt-1">
          <Wrench size={15} className="text-stone-500" />
          <p className="text-base text-gray-600 px-2">
            {action.reason}
          </p>
        </div>
      ))}    
    </>
  )
};

export default TaskActionRibbon;